// @flow

import React from "react";
import { localize } from "redux-i18n";
import { Button, Form, FormGroup, Label, View } from "@components";
import { reduxForm, Field } from "redux-form";
import type { FormProps } from "redux-form";
import { DatePickerFormWrapper } from "@components/form";
import moment from "moment";
import config from "@config";
type Props = $Exact<{
  onSubmit: () => void,
  initialize: Function,
  ...PropsFromLocalize,
  ...$Exact<FormProps>, // https://stackoverflow.com/a/44771268/220839
}>;

export class AbsenceNotesFilter extends React.Component<Props> {
  resetForm = () => {
    this.props.reset();
    this.props.handleSubmit();
  };

  UNSAFE_componentWillMount() {
    this.props.initialize(
      this.props.initVals
        ? { ...this.props.initVals }
        : {
            fromDate: moment()
              .subtract(365, "days")
              .format("YYYY-MM-DD"),
            toDate: moment().format("YYYY-MM-DD"),
          },
    );
  }

  render() {
    return (
      <Form onSubmit={this.props.handleSubmit}>
        <View direction="row" justifyContent="space-between" flex={1}>
          <View direction="row" gap={4}>
            <FormGroup>
              <Label for="fromDate">{this.props.t("DATE_FROM")}</Label>
              <Field
                name="fromDate"
                component={DatePickerFormWrapper}
                customProps={{ dateFormat: config.dateFormatBE, id: "fromDate" }}
              />
            </FormGroup>
            <FormGroup>
              <Label for="toDate">{this.props.t("DATE_TO")}</Label>
              <Field
                name="toDate"
                component={DatePickerFormWrapper}
                customProps={{ dateFormat: config.dateFormatBE, id: "toDate" }}
              />
            </FormGroup>
            <div className="form-group d-flex align-items-end">
              <Button type="submit" materialIcon="replay_circle_filled">
                {this.props.t("SUBMIT")}
              </Button>
            </div>
            <div className="form-group d-flex align-items-end">
              <Button
                materialIcon="file_download"
                className="ml-2"
                onClick={this.props.onExportAbsenceNotes}
              >
                {this.props.t("EXPORT")}
              </Button>
            </div>
          </View>
          <div className="form-group d-flex align-items-end">
            <Button materialIcon="add_box" onClick={this.props.showAddNotesModal}>
              {this.props.t("ADD")}
            </Button>
          </div>
        </View>
      </Form>
    );
  }
}

export default reduxForm({
  form: "absence-notes-filters",
})(localize()(AbsenceNotesFilter));
